/* unplugin-vue-components disabled */import script from "./MyMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MyMenu.vue?vue&type=script&setup=true&lang=js"

import "./MyMenu.vue?vue&type=style&index=0&id=5bdf1980&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bdf1980"]])

export default __exports__